import Store from 'lightningjs-redux';

import { getIsUnpairedEntering } from '../../logic/pairing/pairing.selectors';

const mapControllers = instance => [
  {
    selector: getIsUnpairedEntering,
    callback: value => {
      instance.isUnpairedEntering = value;
    },
    shouldBeInvokedOnConnect: true,
  },
];

export default Store.control(mapControllers);
